module.exports = require("./se-SE");